import { useState } from 'react';
import PrimaryEmailCard from './primary-email-card';

function PrimaryEmail() {
    const [openConfirmModel, setOpenConfirmModel] = useState(false);
    const [openEmailChangeRequests, setOpenEmailChangeRequests] =
        useState(false);

    return (
        <>
            <div className='max-w-sm flex flex-col py-6 px-2 text-sm text-muted-foreground'>
                <span className='font-bold text-lg text-foreground'>
                    Primary Email
                </span>
                <p className='mb-4'>
                    Your primary email is your main login credential and where
                    you receive account notifications.
                </p>
                <span className='text-foreground italic'>To change it:</span>
                <ul className='text-sm text-muted-foreground pl-8 mb-4'>
                    <li className='mt-4'>
                        Confirm the change from both your old and new email
                        inboxes as a{' '}
                        <span className='font-bold text-foreground'>
                            dual verification
                        </span>{' '}
                        to prevents attackers from changing email even if they
                        access your account.
                    </li>
                </ul>
                <p className=''>
                    <span className='font-bold text-foreground text-[1rem]'>
                        Note:
                    </span>{' '}
                    Your old email remains in use throughout the confirmation
                    process. Only after you successfully confirm from both
                    addresses the system will change your primary email. Keep
                    both inboxes accessible to complete the verification.
                </p>
            </div>
            <PrimaryEmailCard
                openConfirmModel={openConfirmModel}
                setOpenConfirmModel={setOpenConfirmModel}
                openEmailChangeRequests={openEmailChangeRequests}
                setOpenEmailChangeRequests={setOpenEmailChangeRequests}
            />
        </>
    );
}

export default PrimaryEmail;
